/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Concetto del dominio servizio mensa alimentato da un attributo EAV per-bando
 */
export enum CampoMensa {

    DIETA = 'DIETA',

    RELIGIONE = 'RELIGIONE'
}

